import styles from './PriceList.module.scss'
const PriceList: React.FC = () => {
  return (
    <div className={styles.section}>
      <h2>料金表</h2>
      <div className={styles.price_wrapper}>
        <div className={styles.card}>
          <h3>月額ライセンス料金</h3>
          <div className={styles.price_card}>
            <div className={styles.price}>100,000</div>
            <p>円/月(税抜)</p>
          </div>
        </div>
        <p>
          ※初期設定料金は、連携するDatabaseの種類や構造によって変動する場合があります。
          <br />
          ※詳細なお見積りは、お打ち合わせ後にご提出いたします。
        </p>
      </div>
    </div>
  )
}
export default PriceList
